import { React, useState, useEffect } from 'react';
import Select from "react-select";
import LeaseApiService from '../../services/apiService';
import { FaAngleRight } from "react-icons/fa6";
import { FaChevronDown } from "react-icons/fa";
const UnitFeature = ({ tableLoading, setFeaturesList, featuresList }) => {
    const apiService = new LeaseApiService();
    const [expandedTypes, setExpandedTypes] = useState({});

    const groupedFeatures = featuresList?.reduce((acc, item) => {
        if (!acc[item.DescType]) {
            acc[item.DescType] = [];
        }
        acc[item.DescType].push(item);
        return acc;
    }, {});

    const handleSelectChange = (e, index, type) => {
        const checked = e.target.checked;

        const updatedList = [...featuresList];

        const globalIndex = featuresList?.findIndex(
            (item, i) => item.DescType === type && i === index
        );

        if (globalIndex !== -1) {
            updatedList[globalIndex].Value = checked;
        }

        setFeaturesList(updatedList);
    };

    const toggleType = (type) => {
        setExpandedTypes(prev => ({
            ...prev,
            [type]: !prev[type]
        }));
    };
    return (
        <div className="cost-center-section my-3">
            {tableLoading && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'rgba(255,255,255,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                    }}
                >
                    <div className="spinner-border text-primary" role="status" />
                </div>
            )}
            <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                <table className="table table-bordered">
                    <thead className="dynoTable">
                        <tr>
                            <th>Select</th>
                            <th>Description</th>
                            <th>Count</th>
                            <th>Amount</th>
                        </tr>
                    </thead>

                    <tbody>
                        {Object.keys(groupedFeatures).map((type) => (
                            <>
                                <tr
                                    style={{ background: "#e9ecef", fontWeight: "bold", cursor: "pointer" }}
                                    onClick={() => toggleType(type)}
                                >
                                    <td colSpan={4}>
                                        {expandedTypes[type] ? <FaChevronDown size={20} /> : <FaAngleRight size={20} />} Type: {type}
                                    </td>
                                </tr>

                                {/* CHILD ROWS */}
                                {expandedTypes[type] &&
                                    groupedFeatures[type].map((data, index) => (
                                        <tr key={`${type}-${index}`}>
                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    style={{ height: "18px", width: "18px" }}
                                                    checked={data.Value}
                                                    onChange={(e) =>
                                                        handleSelectChange(e, index, type)
                                                    }
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    value={data.Description}
                                                    className="p-1 w-100"
                                                    disabled
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    value={data.Cnt}
                                                    className="p-1 w-100"
                                                    disabled
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    value={data.Amount?.toFixed(2)}
                                                    className="p-1 w-100"
                                                    disabled
                                                />
                                            </td>
                                        </tr>
                                    ))}
                            </>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    )
}
export default UnitFeature